import MyFiles from "../components/editor/MyFiles";
import EditorDashboardLayout from "../components/EditorDashboardLayout";
function EditorMyFilesPage(){
    return(<EditorDashboardLayout>
        <MyFiles/>
    </EditorDashboardLayout>)
}
export default EditorMyFilesPage